export default "__VITE_ASSET__be8574e1__"